import React, { useCallback, useEffect, useRef } from "react";
import { useQuery, useQueryClient } from "react-query";
import toast from "react-hot-toast";
import axios from "apis/axios";
import exportExcel from "utils/exportExcel";
import Modal from "components/Modal";
import { Button } from "styled";
import { Input } from "styled";
import ReactSelect from "react-select";
import { getAllData } from "apis/customApiHandler";
import {getFormattedMonthYear, formatToYYYYMM, formatDateToYYYYMM} from "utils/helpers";
import $ from "jquery";
import { useLocation } from "react-router-dom";
import { trackDownloadAndBulkUploadEvents } from "utils/analytics";
import { ANALYTICS_EVENTS } from "utils/analyticsEvents";

const BulkUpload = ({ handleClick }) => {
    const location = useLocation();
    const [file, setFile] = React.useState(null);
    const [loading, setIsLoading] = React.useState(false);
    const queryClient = useQueryClient();
    const [correctData, setCorrectData] = React.useState([]);
    const [incorrectData, setIncorrectData] = React.useState([]);
    const [errorDump, setErrorDump] = React.useState([]);
    const [selectedFleets, setSelectedFleets] = React.useState([]);
    const [downloading, setDownloading] = React.useState(false)
    const [date, setDate] = React.useState("");
    const fileRef = useRef(null);
  
    let downloadSampleExcelLink =
      "https://jk-fleet.s3.ap-south-1.amazonaws.com/1717578029911-upload_cpkm_sample_file.xlsx";
  
    const handleFileChange = async (e) => {
      try {
        e.preventDefault();
        let file = e.target.files[0];
        let allowedFileTypes = [
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          "application/vnd.ms-excel",
          "text/csv",
        ];
        let regEx = new RegExp(
          allowedFileTypes.map((type) => `^.*${type}$`).join("|")
        );
        if (regEx.test(file.type)) {
          setFile(file);
        }
        if (!regEx.test(file.type)) {
          toast.error("please upload only valid excel or csv file");
          //clear file input
          e.target.value = "";
        }
      } catch (error) {
        //console.log(error);
      }
    };

    console.log({selectedFleets})
  
    const handleSubmit = async () => {
      try {
        let formData = new FormData();
        formData.append("file", file);
        formData.append("fleet", selectedFleets);
        formData.append("monthYear", date);
        setIsLoading(true);
        const response = await axios({
          method: "post",
          url: "/cpkm/upload",
          data: formData,
        });
        const data = await response.data;
        // console.log('data',data); 
        setCorrectData(data?.success);
        setIncorrectData(data?.fail);
        setErrorDump(data?.errorVehicles);
        setFile(null)
        console.log(fileRef)
        fileRef.current.value = null;
        trackDownloadAndBulkUploadEvents(ANALYTICS_EVENTS.SYS_BULK_UPLOAD_CPKM_SUCCESS, "CPKM Upload", location.pathname, { model_name: "Upload CPKM" });
        toast.success("Successfully saved");
        queryClient.invalidateQueries("/cpkm/upload");
      } catch (error) {
        const errMsg = error?.response?.data?.message || error?.message;
        trackDownloadAndBulkUploadEvents(ANALYTICS_EVENTS.SYS_BULK_UPLOAD_CPKM_ERROR, "CPKM Upload", location.pathname, { model_name: "Upload CPKM", errMsg });
        toast.error(
          error?.response?.data?.message
          ? error?.response?.data?.message
          : "Something went wrong"
        );
        setErrorDump(null);
        setCorrectData(null);
        setIncorrectData(null);
      }finally{
        setIsLoading(false);
      }
    };
  
    const handleCorrectDataExport = () => {
      if (correctData?.length > 0) {
        exportExcel(correctData, "correctData");
      } else {
        toast.error("No data to export");
      }
    };
  
    const handleIncorrectDataExport = () => {
      if (errorDump?.length > 0) {
        exportExcel(
          errorDump.map((dt) => ({
            'Registration Number': dt['Registration Number'],
            'Billed KM': dt['Billed KM'],
          })),
          "incorrectData"
        );
      } else {
        toast.error("No data to export");
      }
    };

    const { data: allFleets } = useQuery([`/customer-fleet`], () =>
      getAllData("/customer-fleet", {
        limit: 3000,
      })
    );

    const getFleetOptions = useCallback(() => {
      if (allFleets && allFleets.data && allFleets.data.length) {
        return [
          ...allFleets?.data?.map((fleet) => {
            return {
              value: fleet._id,
              label: fleet.fleetName,
            };
          }),
        ];
      }
    }, [allFleets]);

    const getDownloadFormat = async () => {
      setDownloading(true);
      try {
        const dt = await getAllData("/vehicle/download", {
          ...(selectedFleets?.includes("all")
            ? {
                fleets: null,
              }
            : selectedFleets.length && {
                fleets: selectedFleets.map((fleet) => fleet).join(","),
              }),
          contractType: "CPKM",
        });
        exportExcel(
          dt?.data?.map((x, idx) => ({
            "S.N": idx + 1,
            "Registration Number": x.registrationNumber,
            "Billed KM": 0,
          })),
          "cpkm_vehicles"
        );
      } catch (err) {
        console.log(err);
      } finally {
        setDownloading(false);
      }
    };

  
    return (
      <Modal
        handleClick={handleClick}
        title={"Upload CPKM"}
        className="max-w-2xl"
      >
        <div className="w-full p-8 flex flex-col justify-start items-start">
          <label className="w-full py-3">
            Select Fleets
            <ReactSelect
              styles={{
                control: (base, state) => ({
                  ...base,
                  borderColor: "transparent",
                  minWidth: "100%",
                  "&:hover": {
                    borderColor: "rgb(34 197 94)",
                  },
                }),
              }}
              className="shadow-md rounded-md py-1 mb-2"
              options={getFleetOptions()}
              value={
                selectedFleets &&
                selectedFleets?.map((fleet) => {
                  return {
                    value: fleet,
                    label: getFleetOptions()?.find(
                      (item) => item?.value === fleet
                    )?.label,
                  };
                })[0]
              }
              onChange={(value) => {
                if (value.value === "clear") {
                  setSelectedFleets([]);
                  return;
                }
                setSelectedFleets([value.value]);
              }}
              name="fleets"
            />
          </label>
          <label className="w-full py-3">
            Month Year
            <Input
              type="month"
              id="date"
              name="date"
              max={formatDateToYYYYMM()}
              placeholder={"For eg- "+ getFormattedMonthYear()}
              value={date}
              onChange={(e) => {console.log(e.target.value);
                let month = e.target.value.split("-")[1];
                let year = e.target.value.split("-")[0];
                let today = new Date();
                let todayYear = today.getFullYear();
                let todayyMonth = today.getMonth();
                let endOfMonth = new Date(todayYear, todayyMonth + 1, 0).getTime();
                if(new Date(year, month, 0).getTime() > endOfMonth) return;
                setDate(e.target.value)}}
            />
          </label>
          
          <Button
          className="mt-2"
            // onClick={() => window.open(downloadSampleExcelLink, "_blank")}
            onClick = {()=> {
              getDownloadFormat();
            }}
            disabled= {!selectedFleets?.length || downloading}
            bgSecondary
          >
            {downloading ? "Downloading..." : "Download Format"}
          </Button>
          <Input
            type="file"
            className="shadow-sm mt-4"
            name="excelFile"
            onChange={handleFileChange}
            ref={fileRef}
          />
          <div className="flex gap-4">
            <Button className="mt-8" onClick={handleClick}             disabled={loading}
>
              Cancel
            </Button>
            <Button className="mt-8" onClick={handleSubmit} disabled={!selectedFleets?.length || !date || !file || loading}>
              Upload File
            </Button>
          </div>
  
          <div className="">
            {loading ? <div className="my-4"> Uploading </div> : ""}
            {correctData?.length > 0 && (
              <div>
                <div
                  className="border-b-2 border-green-500 text-green-500 cursor-pointer mt-5 mb-2"
                >
                  Uploaded Data
                </div>
                {correctData.map((dt) => {
                  return <div> {dt} </div>;
                })}
              </div>
            )}
            {incorrectData?.length > 0 && (
              <div>
                <div
                  className="  border-b-2 border-red-500 text-red-500 cursor-pointer mt-10 mb-2"
                >
                  Incorrect Data
                </div>
                {incorrectData.map((dt) => {
                  return <div> {dt} </div>;
                })}
              </div>
            )}
            {errorDump?.length > 0 && (
              <span
                className="  border-b-2 border-red-500 text-red-500 cursor-pointer"
                onClick={handleIncorrectDataExport}
              >
                Download Incorrect Data
              </span>
            )}
          </div>
        </div>
      </Modal>
    );
};

export default BulkUpload;